import { Box } from "@mui/material";
import { styled } from "@mui/system";

export const PageContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "2rem",
  height: "90vh",
  padding:
    document.documentElement.dir === "rtl"
      ? "1rem 6rem 0rem 1rem"
      : "1rem 1rem 0rem 6rem",
}));

export const SidebarBox = styled(Box)(({ theme }) => ({
  flex: "0 0 25%",
  display: "flex",
  flexDirection: "column",
  borderRadius: "8px",
  overflowY: "auto",
  backgroundColor: theme.palette.background.white,
  padding: "1rem",
  position: "relative",
  height: "100%",
}));

export const HeaderRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  marginBottom: "1rem",
});

export const MapContainer = styled(Box)(({ theme }) => ({
  flex: "0 0 60%",
  backgroundColor: "#ffffff",
  borderRadius: "8px",
  height: "88vh",
}));
